import { apiClient } from './api';

export type NotificationType =
  | 'order' | 'payment' | 'delivery' | 'promotion'
  | 'system' | 'support' | 'inventory';

export interface Notification {
  id: number;
  user_id: number;
  type: NotificationType;
  title: string;
  message: string;
  related_id: number | null;
  related_type: string | null;
  is_read: boolean;
  created_at: string;
}

export interface ListNotificationsResult {
  data: Notification[];
  pagination: { total: number; page: number; limit: number; pages: number };
  unread_count: number;
}

export interface CreateNotificationInput {
  user_id: number;
  type: NotificationType;
  title: string;
  message: string;
  related_id?: number | null;
  related_type?: string | null;
}

export async function listNotifications(filters: {
  page?: number;
  limit?: number;
  type?: NotificationType;
  unread_only?: boolean;
} = {}): Promise<ListNotificationsResult> {
  return apiClient.get<ListNotificationsResult>('/notifications', filters as Record<string, any>);
}

export async function createNotification(input: CreateNotificationInput): Promise<Notification> {
  return apiClient.post<Notification>('/notifications', input);
}

export async function markRead(id: number): Promise<Notification> {
  return apiClient.patch<Notification>(`/notifications/${id}/read`, {});
}

export async function markAllRead(): Promise<{ updated: number }> {
  return apiClient.patch<{ updated: number }>('/notifications/read-all', {});
}

export async function deleteNotification(id: number): Promise<void> {
  await apiClient.delete<void>(`/notifications/${id}`);
}
